import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Template } from 'fitforce-document-sync';

export interface LibraryItem {
  type: String;
  item: Template;
}

@Pipe({
  name: 'filterUserLibrary'
})
  /**
   * Searches a user library for items that match search text
   * @param {LibraryItem[]} userLibrary - A user library items
   * @param {string} searchText - text to search
   * @returns {LibraryItem[]} - collection of user library items
   */
@Injectable()
export class FilterUserLibraryPipe implements PipeTransform {
  transform(libraryItems: LibraryItem[], searchText: string): LibraryItem[] {
    if (searchText === undefined) { return libraryItems; }
    // return library items that contain text in name or type
    return libraryItems.filter((libraryItem) => {
      return (
          (libraryItem.type).toLowerCase().indexOf(searchText.toLowerCase()) > -1
        ) || (
          (libraryItem.item.name).toLowerCase().indexOf(searchText.toLowerCase()) > -1
        );
    });
  }
}
